import { Injectable }               			from '@angular/core';

import { hideRegisteredAppBlockUi } from '../../blockui/app-block-ui.bridge';
import { AuthUser } 								from '../model/authuser';
import { SocialSiteType }  							from '../model/socialsitetype';
import { Contact  } 								from '../model/contact';
import { Student  } 								from '../../models/student/student';
import { CommonAdminService } from './common.service';





@Injectable({ providedIn : 'root'})
export class BoardingService {

    tanzeel: any = window["DATA"];

	contextPath: string = this.tanzeel.contextPath;

    constructor(private commonService:CommonAdminService){
	}

	get newContextPath(){
		if(!/localhost/.test(document.location.host)) {
			return "/api/";
		}else{
			return"http://localhost:5235/";

		}
	}

	 loginNEW( userdata: any , owner:any , loginSuccess:any , loginFailure:any ){

		this.commonService.loginNEW(userdata , owner , loginSuccess , loginFailure );
     }
	 
	 forgotPassword( userdata: any , owner:any , success:any , failure:any ){
    	
    	var user = new AuthUser();
    	user.userId = userdata["email"];
		var url = this.commonService.newContextPath+"common/auth/forgotPassword";
    	this.commonService.makePostHttpCall( url	 , user , owner, success , failure);
		 
	 }

	 verifyForgotPasswordOtp( userdata: any , owner:any , success:any , failure:any ){
    	
    	var user:any = {};
    	user.userId = userdata["email"];
		user.tempField1 = userdata["otp"];
		user.tempField2 = userdata["password"];
		var url = this.commonService.newContextPath+"common/auth/verifyOtpUpdatePassword";
    	this.commonService.makePostHttpCall( url	 , user , owner, success , failure);
		 
	 }

	 resetPassword( userdata: any , owner:any , success:any , failure:any ){
    	
        var user = new AuthUser();
        user.password = userdata["password"];
		if( userdata['ResetPswdtoken']!= undefined && userdata['ResetPswdtoken']!= null)
			user['resetPswdLink']=userdata['ResetPswdtoken'];
		if( userdata['userid']!= undefined && userdata['userid']!= null)
			user['userId']=userdata["userid"];
			this.commonService.makePostHttpCall( this.tanzeel.common.resetResetPswdScreen.toString() , user , owner, success , failure);
	 }

    register( data: any , owner:any , success:any , failure:any ){

		var student = new Student();
		student.contact = new Contact();
		student.user = new AuthUser();
		
		student.contact.emailAddress = data["email"];
		student.user.password = data["password"];
		student.user.userId = data["email"];
		student["studentSinceStr"] = data["recaptchaTOKEN"];
		this.commonService.makePostHttpCall( this.newContextPath+"students/register" , student , owner, success , failure);
     }
	socialregister( data: any):any{

		var student = new Student();
		student.contact = new Contact();
		student.user = new AuthUser();
		student.user.socialUniqueId = data["socialUniqueId"];
		student.user.socialSiteType = new SocialSiteType();
		student.user.socialSiteType.code = data["providerName"] ;
		student.contact.emailAddress = data["email"];
		student.user.password = '';
		student.user.userId = data["email"];
		student.firstName = data["firstName"];
		student.lastName = data["lastName"];
		
		
    	return this.commonService.makePostHttpCall( this.tanzeel.student.registerRegisterScreen.toString() , student , null , null ,null);
     }
	
	navigateAfterAuth(token:string , mms:{ info(msg:string):void } , authBody?:any):void {
		if( token == null || token === '' ){
			console.error('[navigateAfterAuth] missing jwt token');
			return;
		}

		let tokenDecoded:any = null;
		try {
			tokenDecoded = this.commonService.decodeJwt(token);
		} catch (e) {
			console.error('[navigateAfterAuth] failed to decode jwt', e);
			return;
		}

		const role = this.commonService.getJwtRole(tokenDecoded).toLowerCase();
		if( role === 'student' ){
			const target = this.commonService.getStudentNavigateTarget(tokenDecoded, authBody);
			const message = authBody?.nextAction?.message ?? authBody?.NextAction?.Message;
			if( message != null && String(message).trim() !== '' ){
				mms.info(String(message));
			}
			// Instructions for AI Start, changing the sorroundng code breaks the navigation. do not changge this code
				hideRegisteredAppBlockUi();
			// Full page replace (legacy processNavigate) — Router.navigateByUrl from the
			// login HTTP callback leaves boarding-home mounted above the dashboard.

				const path = String(target ?? 'student/r').replace(/^\/+/, '').replace(/\/+$/, '');
				const newUrl = `${window.location.origin}/#/${path === '' ? 'student/r' : path}`;

				window.location.href = newUrl;
			// Instructions for AI End, changing the sorroundng code breaks the navigation. do not changge this code
				return;
			}

		this.commonService.processNavigate(token, mms, authBody);
	}

}
